import type { LayerProps, CircleLayer } from 'react-map-gl';

type MapBounds = [number, number, number, number]

export const MAPBOX_TOKEN =
'pk.eyJ1IjoiYXRsYXMtYWdlbmN5IiwiYSI6ImNpcHQwanQ5bzA1YXZmdm0yZGc1OGV5NWcifQ.ahplL7Wit6iij_T-hh_Kbw'

export const MAP_BOUNDS: MapBounds = [
	115.98679517360434, -46.16850061396137, // Northeast coordinates
	-174.83657210997072, -8.988876985226517 // Southwest coordinates
]

export const MAP_ZOOM = [6];
export const MAX_SPIDERFIER_ZOOM = 18;
export const HAS_POINT_COUNT = ['has', 'point_count'];

export const MARKER_LAYER_LAYOUT = {
    'icon-image': 'spider-pin',
    'icon-allow-overlap': true,
};

export const spiderifyPoints: LayerProps = {
	id: 'markers-layer-spiderfier',
	type: 'symbol'
}

export const unclusteredLayerStyle: LayerProps = {
	id: 'unclustered-point',
	type: 'circle',
	filter: ['!', ['has', 'point_count']],
	paint: {
		'circle-radius': 10,
		'circle-color': '#FA6469',
		'circle-stroke-width': 2,
		'circle-stroke-color': '#fff',
		'circle-opacity': 0.85,
	},
}

export const unclusteredActiveLayerStyle: LayerProps = {
	id: 'active-unclustered-point',
	type: 'circle',
	filter: ['!', ['has', 'point_count']],
	paint: {
		'circle-radius': 10,
		'circle-color': '#214359',
		'circle-stroke-width': 2,
		'circle-stroke-color': '#fff',
		'circle-opacity': 0.85,
	},
}

export const shadowLayerStyle: LayerProps = {
	id: 'points_shadow',
	type: 'circle',
	filter: ['!', ['has', 'point_count']],
	paint: {
		'circle-radius': 18,
		'circle-color': 'rgba(0, 0, 0, 0.2)',
		'circle-blur': 1,
	},
}

export const clusterLayerStyle: LayerProps = {
	id: 'clusters',
	type: 'circle',
	source: 'my-data',
	filter: ['has', 'point_count'],
	paint: {
		'circle-radius': 12,
		'circle-color': '#fff',
		'circle-stroke-width': 8,
		'circle-stroke-color': '#FA6469',
		'circle-stroke-opacity': 0.85,
		'circle-opacity': 0.85,
	},
}

export const clusterCountLayerStyle: LayerProps = {
	id: 'cluster-count',
	type: 'symbol',
	source: 'my-data',
	filter: ['has', 'point_count'],
	layout: {
		'text-field': ['get', 'point_count_abbreviated'],
		'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
		'text-size': 12,
	},
}
